import React, { Fragment, useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FilterPills from './FilterPills';
import FilterPillsSticky from './FilterPillsSticky';

const FilterPillsContainer = ({ stickyFilter, stickyFilterDisplay }) => {
    const dispatch = useDispatch();
    const {
        facetFilters: globalFacetFilters,
        navigationTheme,
        productsViewCachedId,
    } = useSelector(state => state.facetedSearch);

    const [facetFilters, setFacetFilters] = useState(globalFacetFilters || []);
    const previousCachedId = useRef(productsViewCachedId);
    useEffect(() => {
        if (previousCachedId.current !== productsViewCachedId) {
            setFacetFilters(globalFacetFilters);
            previousCachedId.current = productsViewCachedId;
        }
    }, [globalFacetFilters, productsViewCachedId]);

    return (
        <Fragment>
            {stickyFilterDisplay && (
                <FilterPillsSticky
                    {...{
                        facetFilters: globalFacetFilters,
                        stickyFilterDisplay: stickyFilterDisplay,
                        stickyFilter: stickyFilter,
                    }}
                />
            )}
            {!stickyFilterDisplay && (
                <FilterPills
                    {...{
                        facetFilters: globalFacetFilters,
                    }}
                />
            )}
        </Fragment>
    );
};

export default FilterPillsContainer;
